import { frontendURL } from 'dashboard/helper/URLHelper.js';

import WhatsAppCampaignAnalyticsPage from './pages/WhatsAppCampaignAnalyticsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// import OneoffCampaignsPage from './pages/OneoffCampaignsPage.vue';
// import OngoingCampaignsPage from './pages/OngoingCampaignsPage.vue';
import SettingsContent from '../settings/Wrapper.vue';
import Index from '../settings/campaigns/Index.vue';
import OneOffReport from '../settings/campaigns/oneoff/ReportPage.vue';
import OngoingReport from '../settings/campaigns/ongoing/ReportPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'manager'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: Index,
      meta,
      children: [
        {
          path: '',
          redirect: 'one_off',
        },
        {
          path: 'one_off',
          name: 'one_off',
          meta,
          component: { ...Index },
        },
        {
          path: 'ongoing',
          name: 'ongoing_campaigns',
          meta,
          component: { ...Index },
        },
        {
          path: 'whatsapp/:campaignId/analytics',
          name: 'campaigns_whatsapp_analytics',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignAnalyticsPage,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      meta,
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.REPORT.RESULT',
        icon: 'arrow-trending-lines',
        showNewButton: false,
        showSidemenuIcon: false,
        showBackButton: true,
      },
      children: [
        {
          path: 'one_off/:campaignDisplayId',
          name: 'one_off_campaign_report',
          component: OneOffReport,
          meta,
        },
        {
          path: 'ongoing/:campaignId',
          name: 'ongoing_campaign_report',
          component: OngoingReport,
          meta,
        },
      ],
    },
    // {
    //   path: frontendURL('accounts/:accountId/campaigns'),
    //   component: CampaignsPageRouteView,
    //   children: [
    //     {
    //       path: '',
    //       redirect: to => {
    //         return { name: 'campaigns_ongoing_index', params: to.params };
    //       },
    //     },
    //     {
    //       path: 'one_off',
    //       name: 'one_off',
    //       meta,
    //       redirect: to => {
    //         return { name: 'campaigns_one_off_index', params: to.params };
    //       },
    //     },
    //     {
    //       path: 'ongoing',
    //       name: 'ongoing',
    //       meta,
    //       redirect: to => {
    //         return { name: 'campaigns_ongoing_index', params: to.params };
    //       },
    //     },
    //     {
    //       path: 'one_off',
    //       name: 'campaigns_one_off_index',
    //       meta,
    //       component: OneoffCampaignsPage,
    //     },
    //     {
    //       path: 'ongoing',
    //       name: 'campaigns_ongoing_index',
    //       meta,
    //       component: OngoingCampaignsPage,
    //     },
    //     {
    //       path: 'ongoing',
    //       name: 'campaigns_ongoing_index',
    //       meta,
    //       redirect: to => {
    //         return { name: 'campaigns_livechat_index', params: to.params };
    //       },
    //     },
    //     {
    //       path: 'one_off',
    //       name: 'campaigns_one_off_index',
    //       meta,
    //       redirect: to => {
    //         return { name: 'campaigns_sms_index', params: to.params };
    //       },
    //     },
    //     {
    //       path: 'live_chat',
    //       name: 'campaigns_livechat_index',
    //       meta,
    //       component: LiveChatCampaignsPage,
    //     },
    //     {
    //       path: 'sms',
    //       name: 'campaigns_sms_index',
    //       meta,
    //       component: SMSCampaignsPage,
    //     },
    //   ],
    // },
  ],
};

export default campaignsRoutes;
